import $ from '@modules/jquery-import';
import Modernizr from 'modernizr';

$.fn.dropDownMenu = function ( o ) {
    this.timeoutId = null;

    var opt = $.extend( true, {
        open: 'fadeIn',
        close: 'fadeOut',
        openEvent: 'mouseenter touchstart',
        closeEvent: 'mouseleave',
        touchEvents: 'touchstart',
        openDuration: 150,
        closeDuration: 150,
        openTimeout: 100, // min delay of 100ms eliminates flash from multiple opens in IE
        closeTimeout: 400,
        menuSelector: '.menu',
        outerMenuSelector: null,
        preventDefault: false
    }, o || {} );

    var _dropdown = this,
        collection = [],
        supportsCssTransitions = (Modernizr && Modernizr.csstransitions) || false;

    /* PUBLIC */
    this.showMenu = function () {
        $.each( collection, function ( i, item ) {
            item.showMenu();
        } );
        return collection;
    };
    this.hideMenu = function ( currentTarget ) {
        $.each( collection, function ( i, item ) {
            if ( item[0] !== currentTarget ) {
                item.hideMenu();
            }
        } );
        return collection;
    };
    this.flashMenu = function ( timer ) {
        var timer = parseInt( timer ) || 4000;
        $.each( collection, function ( i, item ) {
            item.showMenu();
            item.timeoutId = setTimeout( function () {
                item.hideMenu();
            }, timer );
        } );
        return collection;
    };
    this.destroy = function () {
        $.each( collection, function ( i, item ) {
            item.destroy();
        } );
        return collection;
    };

    /* !Don't use $.fn.extend here! - causes object to behave as a singleton*/
    return this.each( function () {
        /* _PRIVATE */
        var $trigger = $( this );
        var $menu = (opt.outerMenuSelector) ? $( opt.outerMenuSelector ) : $trigger.find( opt.menuSelector );
        var isMousedown = 0;
        return {
            initialize: function () {
                var _this = this;
                collection.push( this );
                // add enabled class for PE
                $trigger.addClass( 'enabled' );

                // handle menu close for mobile devices
                $trigger.on( 'click', '[data-close-menu]', function ( e ) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.cancelTimeout( _this.timeoutId );
                    _this.hideMenu();
                } );

                // hide menu if document clicked
                $( document ).on( 'click menu:close', _this.hideMenu );

                $trigger.on( ['click', opt.openEvent, opt.closeEvent].join( ' ' ), this.handleHover.bind( this ) );

                $menu.on( 'mouseenter', opt.outerMenuSelector ? opt.menuSelector : null, function () {
                    _this.cancelTimeout( _this.timeoutId );
                } );

                $menu.on( 'mousedown mouseup mousemove', function ( e ) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    return !(isMousedown = (e.type == 'mousedown') ? 1 : 0);
                } );

                $trigger.attr( 'hoverState', 0 );

                $trigger.on( 'menu:destroy', function () {
                    _this.destroy();
                } );

                if ( opt.preventDefault ) {
                    $trigger.children( ':first-child' )
                        .on( [opt.openEvent, opt.closeEvent, opt.touchEvents].join( ' ' ), function ( e ) {
                            e.preventDefault();
                        } );
                }

                return this;
            },

            destroy: function () {
                $trigger.removeAttr( 'hoverState' );
                $trigger.removeClass( 'enabled' );
                $trigger.off( [opt.openEvent, opt.closeEvent].join( ' ' ) );
                $trigger.off( 'menu:destroy' );
                $menu.off( [opt.openEvent, opt.closeEvent].join( ' ' ) );
                $menu.removeClass( 'on' ).removeAttr( 'style' );
            },

            handleHover: function ( e ) {
                // cancel actions if disabled
                this.cancelTimeout( this.timeoutId );
                if ( $trigger.hasClass( 'disabled' ) || isMousedown ) {
                    return;
                }

                var _this = this,
                    hoverstate = $trigger.attr( 'hoverState' );

                if ( e.type === 'click' || e.type == 'touchstart' ) {
                    // if menu is open allow click through on menu item
                    if ( $menu[0] && $trigger[0] === e.currentTarget ) {
                        e.stopPropagation();
                        var menuContainsTarget = $.contains( $menu[0], e.target );
                        if ( !menuContainsTarget ) {
                            if ( hoverstate == 1 ) {
                                return true;
                            }
                            else {
                                // global event: close all open menu instances
                                $( document ).trigger( 'menu:close', [$menu] );
                                _this.showMenu();
                                return false;
                            }
                        }
                        return menuContainsTarget;
                    }
                    // else return true
                }
                else if ( e.type === opt.closeEvent ) {
                    if ( hoverstate == 1 ) {
                        this.timeoutId = setTimeout( function () {
                            _this.hideMenu();
                        }, opt.closeTimeout );
                    }
                }
                else {
                    e.stopImmediatePropagation();
                    if ( hoverstate != 1 ) {
                        this.timeoutId = setTimeout( function () {
                            _dropdown.hideMenu( $menu[0] );
                            _this.showMenu();
                        }, opt.openTimeout );
                    }
                }
            },
            showMenu: function () {
                // only trigger event if menu is actually closed
                if ( $trigger.attr( 'hoverState' ) == 0 ) {
                    $menu[opt.open]( opt.openDuration );
                    $menu.trigger( 'menu-open' );
                    $trigger.attr( 'hoverState', 1 ).addClass( 'on' );
                }
            },

            hideMenu: function () {
                $menu.scrollTop( 0 );
                // only trigger event if menu is actually open
                if ( $trigger.attr( 'hoverState' ) == 1 ) {
                    $menu[opt.close]( opt.closeDuration );
                    $menu.trigger( 'menu-close' );
                    $trigger.attr( 'hoverState', 0 ).removeClass( 'on' );
                }
            },

            _cancel_close: function ( e ) {
                this.handleHover( e );
            },

            cancelTimeout: function ( timeoutId ) {
                if ( timeoutId ) {
                    clearTimeout( timeoutId );
                    timeoutId = null;
                }
            }
        }.initialize();
    } );

    return collection;

};

$.fn.dropDownSelect = function ( o ) {
    var opt = $.extend( {
        openEvent: 'click',
        openTimeout: 0,
        openDuration: 100,
        open: 'slideDown',
        preventDefault: false
    }, o || {} );

    return $.fn.dropDownMenu.call( this, opt );
};

export default $.fn.dropDownMenu;
